<template>
  <div class="row tabs">
    <div class="tab" v-for="(item, index) in tabs" :key="index"
      :class="{'active': index === activeIndex}" 
      @click="onTabClick(item, index)">{{item}}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tabs: {
      type: Array,
      default: () => []
    },
    activeTabIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      activeIndex: 0
    };
  },
  methods: {
    onTabClick(item, index) {
      this.activeIndex = index;
      this.$emit('change', {
        item,
        index
      });
    }
  },
  mounted() {
    this.activeIndex = this.activeTabIndex;
  }
};
</script>

<style lang="scss" scoped>
.tabs { 
  padding: 2px;
  height: 26px;
  line-height: 26px;
  border-radius: 2px;
  background-color: #f7f8fc;
  .tab {
    height: 22px;
    line-height: 22px;
    padding: 0px 8px;
    border-radius: 2px;
    font-size: 14px;
    color: #9ea1b4;
    cursor: pointer;
    &.active {
      color: #464d6c;
      background-color: #ffffff;
    }
  }
}
</style>

